import { DateHelper } from '@helpers/date.helper';

export interface BrandJson {
  id: number;
  name: string;
  logo_file_id: string;
  archived_at?: string;
}

export class Brand {
  constructor(
    public id?: number,
    public name?: string,
    public logoFileId?: string,
    public archivedAt?: Date
  ) {}

  static fromJson(json: BrandJson): Brand {
    return new Brand(
      json.id,
      json.name,
      json.logo_file_id,
      json.archived_at ? DateHelper.fromUtc(json.archived_at) : null
    );
  }

  static toJson(brand: Brand): Omit<BrandJson, 'logo_file_id'> {
    return {
      id: brand.id,
      name: brand.name,
      archived_at: brand.archivedAt ? DateHelper.format(brand.archivedAt, 'YYYY-MM-DD HH:mm:ss') : null
    };
  }
}
